export const getLocalized = (data, field, language) => {
    if (!data) return '';
    // If language is English and the _en field exists and is not empty
    if (language === 'en' && data[`${field}_en`]) {
        return data[`${field}_en`];
    }
    // Fallback to original field (default language/Turkish)
    return data[field] || '';
};
